module.exports = __webpack_public_path__ + "img/xiaoyi_order1.fb101717.gif";